import { PollForNotifications } from "../utils/PollForNotifications";
import { QPollNotificationsRFC } from "./QPollNotificationsRFC";
import { wait } from "../utils/wait";
import { Globals } from "./Globals";

export class QNotificationMgr {
  constructor() {
    this.fMessageList = null;
    this.fWSMgr = null;
    this.fNotificationCenter = null;
    this.fActivePoll = false;
  }

  InitNotificationMgr(wsmgr) {
    this.fWSMgr = wsmgr;
    this.fMessageList = [];
  }

  LoadMessages(messages) {
    this.fMessageList = messages;
    var forceRead = this.SetReadMessages();
    // bypass force show notification center when admin login
    if (forceRead && !this.fNotificationCenter && !this.fWSMgr.fAdminLogin) {
      this.fWSMgr.CreateNotificationCenter();
      this.fNotificationCenter.ShowFirstForceUnread();
    }
  }

  SetReadMessages() {
    var forceRead = false;
    var userinfo = Globals._wsMgr.GetUserInfo();
    var readMessageIds = userinfo.GetReadMessages();
    for (var m = 0; m < this.fMessageList.length; m++) {
      var theMessage = this.fMessageList[m];
      theMessage["didRead"] = readMessageIds.includes(theMessage["id"]);
      if (!theMessage["didRead"] && theMessage["forceRead"]) forceRead = true;
    }
    return forceRead;
  }

  IsMessageRead(mID) {
    var message = this.GetMessageByID(mID);
    if (message == null) return false;
    return message["didRead"];
  }

  GetMessageByID(messageID) {
    var message = null;
    var messageList = this.GetMessages();
    for (var i in messageList) {
      var curMessage = messageList[i];
      if (curMessage["id"] == messageID) {
        message = curMessage;
        break;
      }
    }
    return message;
  }

  GetMessages() {
    return this.fMessageList;
  }

  MarkMessageRead(id) {
    // dont mark messages read when support login
    if (this.fWSMgr.fAdminLogin) return;

    var unreadIds = this.GetUnreadMessageIDs();
    if (!unreadIds.includes(id)) return;

    this.ActivateListener(); //Fire off a call in 5 seconds to update the backend with new message IDs.

    var curMessage = this.GetMessageByID(id);
    curMessage["didRead"] = true;

    var ui = this.fWSMgr.GetUserInfo();
    ui.MarkMessageRead(id);
  }

  UpdateUI() {
    if (this.fNotificationCenter) this.fNotificationCenter.UpdatePanels();
    if (this.fWSMgr.fTopRightFrameless) this.fWSMgr.fTopRightFrameless.UpdatePanel();
    this.fWSMgr.UpdateDocTitle();

    this.fWSMgr.PrepRenderWS();
    this.fWSMgr.RenderWS();
  }

  GetUnreadMessageIDs() {
    var unreadMessages = this.GetUnreadMessages();
    if (unreadMessages == null || unreadMessages.length === 0) return [];
    return unreadMessages.map(function (a) {
      return a["id"];
    });
  }

  GetUnreadMessages() {
    var scope = this;
    var messages = this.GetMessages();
    if (messages == null) return [];
    return messages.filter(function (a) {
      return !scope.IsMessageRead(a["id"]);
    });
  }

  GetUnreadMessagesCount() {
    return this.GetUnreadMessages().length;
  }

  GetUnreadForceReadMessages() {
    return this.fMessageList.filter(function (a) {
      return a["forceRead"] && !a["didRead"];
    });
  }

  GetUnreadForceReadMessagesCount() {
    return this.GetUnreadForceReadMessages().length;
  }

  SetActivePoll(active) {
    this.fActivePoll = active;
  }

  IsActivePoll() {
    return this.fActivePoll === true;
  }

  ActivateListener() {
    //Restart the listener when prompted.
    if (Globals._accountInfo.fDoNotPoll) return;
    this.KillListener();
    this.QueueNextPoll(1);
  }

  KillListener() {
    clearTimeout(this.fPollListener);
  }

  // defaults to 60 second wait - should not override this except on initial activation of listener
  QueueNextPoll(waitSeconds = 60) {
    this.SetActivePoll(false);
    this.fPollListener = setTimeout(function () {
      PollForNotifications();
    }, waitSeconds * 1000);
  }

  SendNextPoll() {
    var wsMgr = this.fWSMgr;
    var accountName = wsMgr.GetAccountName();
    var user = wsMgr.GetUserName();

    var loadOverridesRFC = new QPollNotificationsRFC();
    loadOverridesRFC.InitRFC();
    loadOverridesRFC.SetParams(accountName, user);
    Globals._rfcMgr.QueueRFC(loadOverridesRFC);

    this.SetActivePoll(true);
  }
}
